import React, { useState } from 'react';
import { LoaderContext } from '../../../context';
import LoaderComponent from '../LoaderComponent';

const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
      {loading && <LoaderComponent />}
    </LoaderContext.Provider>
  );
};

export default LoaderProvider;